import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** Bank details updating request body */
export interface BankDetailsUpdateInterface {
  /** Unique identifier. Required by some other bodies. */
  id?: number;
  /** Checking account name */
  name?: string;
  /** Checking account number */
  bank?: BankFindInterface;
  /** Checking account number */
  checkingAccount?: string;
  /** Contragent which use this bank details */
  contragent?: ContragentFindInterface;
  /** Company which use this bank details */
  company?: CompanyFindInterface;
}

/** Bank details updating request body - DTO schema */
export const BankDetailsUpdateDto = SerdeDtoClass.create<BankDetailsUpdateInterface>(ClientDtoKeysEnum.BANK_DETAILS_UPDATE_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    optional: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  bank: {
    optional: true,
    label: 'Банк',
    serializer: entityLikeSchema,
  },
  checkingAccount: {
    optional: true,
    label: 'Рассчетный счет',
    serializer: nonEmptyStringSchema,
  },
  contragent: {
    optional: true,
    label: 'Контрагент',
    serializer: entityLikeSchema,
  },
  company: {
    optional: true,
    label: 'Компания',
    serializer: entityLikeSchema,
  },
});
